/* eslint-disable camelcase */
import { createSelector } from 'reselect'
import { getCandidateProfile } from '../modules/candidate'

// TODO [MoScoW]: Add selector tests
const staticData = state => state.static_data
const getCities = state => state.static_data.cities

const countriesSelector = createSelector([staticData], subState => subState.countries)
const citiesSelector = createSelector([staticData], subState => subState.cities)

export const availableCountries = createSelector([countriesSelector, citiesSelector, getCandidateProfile], (countries, cities) => {
  const countriesByDate = countries.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
  return countriesByDate.map(country => {
    return {
      ...country,
      cities: cities.filter(({ country_id }) => country_id === (country && country.id)),
    }
  })
})

export const locationOsmStrings = createSelector([getCities], cities => ({
  ...cities
    .filter(city => city.name !== 'Remote' && city.name !== 'Other')
    .reduce(
      (prev, curr) => ({
        ...prev,
        [curr.id]: {
          comprehensiveLocation: curr.comprehensive_location,
        },
      }),
      {},
    ),
}))
